/**
 * @generated SignedSource<<d5cc7845aa3174897470332e27d02f5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoleListItem_role$data = {
  readonly employees: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemEmployees_employees">;
  }>;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "RoleListItem_role";
};
export type RoleListItem_role$key = {
  readonly " $data"?: RoleListItem_role$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoleListItem_role">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoleListItem_role",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employees",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemEmployees_employees"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};

(node as any).hash = "3cdc9b28e6415c9e640027b65230be0c";

export default node;
